<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="query['owner.id']" :options="owners" clearable placeholder="placeholder.owner" @change="refresh"/>
        <vxe-input v-model="query.no" clearable placeholder="business.label.no" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" clearable placeholder="business.label.name" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column :formatter="({row})=>getStrings(row.owners,'name')" field="owners" title="business.label.owner" width="150"/>
        <vxe-column field="no" title="business.label.itemNo" width="100"/>
        <vxe-column field="name" title="business.label.ChineseName" width="300"/>
        <vxe-column field="mnemonicCode" title="business.label.mnemonicCode" width="150"/>
        <vxe-column field="itemType.name" title="business.label.itemType" width="80"/>
        <vxe-column field="itemCategory.name" title="business.label.itemCategory" width="80"/>
        <vxe-column field="legalAttribute.name" title="business.label.legalAttribute" width="80"/>
        <vxe-column field="brand.name" title="business.label.brand" width="80"/>
        <vxe-column field="season.name" title="business.label.season" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:dataSources}" field="dataSource" title="business.label.dataSource" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:saleClassifications}" field="saleClassification" title="business.label.saleClassification" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:storageClassifications}" field="storageClassification" title="business.label.storageClassification" width="80"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:storageEnvironments}" field="storageEnvironment" title="business.label.storageEnvironment" width="80"/>
        <vxe-column field="daysOfExpirationNearly" title="business.label.daysOfExpirationNearly" width="100"/>
        <vxe-column field="daysOfProductionNearly" title="business.label.daysOfProductionNearly" width="100"/>
        <vxe-column field="daysOfInspectionNearly" title="business.label.daysOfInspectionNearly" width="100"/>
        <vxe-column field="numberOfLot" title="business.label.numberOfLot" width="80"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="importation" title="business.label.importation" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="valuable" title="business.label.valuable" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="supervised" title="business.label.supervised" width="70"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="business.label.config" icon="vxe-icon-association-form" status="danger" @click.stop="config(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { Item } from '@/api/dto/common/Item'
import { getStrings } from '@/utils/util'

export default {
  name: 'ItemTable',
  props: {
    owners: { type: Array, default: [] },
    dataSources: { type: Array, default: [] },
    saleClassifications: { type: Array, default: [] },
    storageClassifications: { type: Array, default: [] },
    storageEnvironments: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      query: { no: '', name: '', 'owner.id': undefined },
      list: [],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    getStrings,
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('itemFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.list = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = { no: '', name: '', 'owner.id': undefined }
      this.refresh()
    },
    add() {
      this.$emit('add')
    },
    edit(row, copy) {
      this.$emit('edit', row.id, copy)
    },
    config(row) {
      this.$emit('config', new Item(row))
    }
  }
}
</script>